export class Tache {
    id: number;
    name: string;
}


